module.exports = __webpack_public_path__ + "img/Picture36.04860e85.png";